import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import ViewHelper from '../../helpers/ViewHelper';
import Rating from './Rating';

export default class ItemWithPhoto extends Component {
  titleCase(sentence) {
    let sentenceString = sentence.toString().split(' ');
    for (let i = 0; i < sentenceString.length; i++) {
      if (i !== 0) {
        sentenceString[i] = sentenceString[i].toLowerCase();
      }
    }
    return sentenceString.join(' ');
  }

  render() {
    let { menu, _location } = this.props;
    const price = ViewHelper.toCurrency(
      menu.menu_price,
      _location.currency,
      _location.decimal_places
    );
    const discounted = ViewHelper.toCurrency(
      this.props.discountedPrice,
      _location.currency,
      _location.decimal_places
    );
    if (this.props.grid_layout === 'old') {
      return (
        <div className="sticky-top card-color">
          <div className="flex-column-space-between center-aligned p-3">
            {this.props.goBack && (
              <FontAwesomeIcon
                className="f0"
                onClick={this.props.goBack}
                size={'sm'}
                icon={faArrowLeft}
                color='var(--card-font-color)'
              />
            )}
            <div className="rating-bg">
              <Rating item={menu} settings={this.props.locationSettings} />
            </div>
          </div>
          <div className="flex-column-space-between pb-3 mt-2">
            <div className="f0 card-color">{menu.menu_name}</div>
            <div className="f1 item-price flex-column fw-normal card-color">
              {menu.menu_price === menu.discounts.discountedPrice ? (
                price
              ) : (
                <>
                  <span className="card-font-color">{discounted}</span>{' '}
                  <span className="text-decoration-line-through">{price}</span>
                </>
              )}
            </div>
          </div>
        </div>
      );
    } else if (this.props.grid_layout !== 'old') {
      return (
        <div className="sticky-top card-color">
          <div className="flex-column-space-between center-aligned p-3">
            {this.props.goBack && (
              <FontAwesomeIcon
                className="f0"
                onClick={this.props.goBack}
                size={'sm'}
                icon={faArrowLeft}
              />
            )}
            <div className="rating-bg-custom">
              <Rating item={menu} settings={this.props.locationSettings} />
            </div>
          </div>
          <div className="flex-column-space-between item-modifier-without-photo-name ps-3 pe-3 pb-3 mt-2">
            <div className="f0">
              <h1 className={'item-modifier-menu-name card-font-color f0'}>{menu.menu_name}</h1>
            </div>
            <div className="f1 item-price card-font-color">
              {menu.menu_price === menu.discounts.discountedPrice ? (
                price
              ) : (
                <>
                  <span className="card-font-color">{discounted}</span>{' '}
                  <span className="text-decoration-line-through">{price}</span>
                </>
              )}
            </div>
          </div>
        </div>
      );
    }
  }
}
